import {POLICE_CODES} from '@guestapp/sdk';
import {useGuestGroup} from './useGuestGroup';
import {useReservationSettings} from './useReservationSettings';
import {useReservation} from 'context/reservation';

export function useGetReservationType() {
  const {guestGroup, isSuccess} = useGuestGroup();
  const {housing} = useReservation();
  const {checkCanEditReservationDetails} = useReservationSettings();

  const isFeratelReservation = housing?.police_account_type === POLICE_CODES.feratel;
  const isNumberOfGuestsEditable = checkCanEditReservationDetails();
  const hasReservationGroup = isNumberOfGuestsEditable
    ? isFeratelReservation
    : (guestGroup?.known_number_of_guests ?? 0) > 1 && isFeratelReservation;

  return {
    isFeratelReservation,
    isNumberOfGuestsEditable,
    hasReservationGroup,
    isLoaded: isSuccess,
  };
}
